import { UPDATE_PATH } from './actionTypes';
export const updatePath = (data) => ({ type: UPDATE_PATH, data });
